//@ts-ignore
//@ts-nocheck
import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import { ThemeContext } from "@emotion/react";
import styled from "@emotion/styled";
import propTypes from "prop-types";
import React, { Fragment } from "react";
// import { space } from "styled-system";
import themeGet from "@styled-system/theme-get";
import AddressInput from "../form-elements/AddressInput";

let borderRadiusOptions = {
  noLeftBorder: `0 4px 4px 0`,
  noRightBorder: `4px 0 0 4px`,
  noBorder: `0px`,
  fullBorder: `4px`,
};

function generateBorderRadius({ leftBlock, rightBlock }) {
  let { noLeftBorder, noRightBorder, noBorder, fullBorder } =
    borderRadiusOptions;
  if (leftBlock && !rightBlock) {
    return noLeftBorder;
  } else if (rightBlock && !leftBlock) {
    return noRightBorder;
  } else if (leftBlock && rightBlock) {
    return noBorder;
  } else {
    return fullBorder;
  }
}

const StyledInput = styled.input`
  width: 100%;
  height: ${({ size, theme }: any) => theme.size.input[size].height}px;
  line-height: ${({ size, theme }: any) => theme.size.input[size].height}px;
  font-size: ${({ size, theme }: any) => theme.size.input[size].fontSize}px;
  padding: 0 12px;
  border: 2px solid;
  border-color: ${(props: any) =>
    props.isInvalid ? themeGet("colors.red.500") : themeGet("colors.gray.200")};
  border-radius: ${(props: any) => generateBorderRadius(props)};
  transition: all 0.2s ease-in-out;

  padding-left: ${({ leftIcon, size, theme }: any) =>
    leftIcon && theme.size.input[size].iconPadding + "px"};

  padding-right: ${({ rightIcon, rightElem, size, theme }: any) =>
    (rightIcon || rightElem) && theme.size.input[size].iconPadding + "px"};

  &::placeholder {
    color: ${themeGet("colors.gray.200")};
  }

  &:hover {
    border-color: ${(props: any) =>
      props.isInvalid
        ? themeGet("colors.red.500")
        : themeGet("colors.gray.200")};
  }

  &:focus {
    box-shadow: 0 0 0 3px
      ${(props: any) =>
        props.isInvalid
          ? themeGet("colors.red.200")
          : themeGet(`colors.${props.color}.lightest`)};

    border-color: ${(props: any) =>
      props.isInvalid
        ? themeGet("colors.red.500")
        : themeGet(`colors.${props.color}.primary`)};
  }

  &:disabled {
    border-color: ${themeGet("colors.gray.200")};
    background-color: ${themeGet("colors.gray.200")};
    color: ${themeGet("colors.gray.200")};
    cursor: not-allowed;
  }
`;

const Feedback = ({
  isInvalid,
  helpText,
  errorMessage,
  isDisabled,
  theme: { colors },
  size,
}) => (
  <Fragment>
    {isInvalid && errorMessage ? (
      <HelperText size={size} icon="error" color="red.500">
        {errorMessage}
      </HelperText>
    ) : (
      helpText && (
        <HelperText size={size} color={isDisabled ? "gray.200" : "gray.400"}>
          {helpText}
        </HelperText>
      )
    )}
  </Fragment>
);

const space = "";
const Label: any = styled.label`
  ${({ size }: any) => themeGet(`font.label.${size}`)}
  font-weight: ${themeGet(`typography.fontWeights.text.medium`)};
  ${space}
`;

Label.defaultProps = {
  size: "regular",
};

const helpTextSizes: any = {
  big: {
    size: "small",
    marginTop: 8,
  },
  regular: {
    size: "small",
    marginTop: 8,
  },
  small: {
    size: "smaller",
    marginTop: 4,
  },
};

const HelperText: React.FC<any> = ({ size, icon, color, children }) => (
  <Text
    size={helpTextSizes[size].size}
    leftIcon={icon}
    color={color}
    mt={helpTextSizes[size].marginTop + "px"}
  >
    {children}
  </Text>
);

const IconWrapper = styled(Box)`
  position: absolute;
  display: flex;
  align-items: center;
  transform: translateY(-50%);
  top: 50%;
  left: ${(props) => props.iconPos === "left" && "13px"};
  right: ${(props) => props.iconPos === "right" && "13px"};
`;

const IconBox: React.FC<any> = ({ color, icon, iconPos, iconSize }) => (
  <IconWrapper iconPos={iconPos}>
    <Icon name={icon} color={color} size={iconSize} />
  </IconWrapper>
);

const Input = ({
  placeholder,
  type,
  style,
  isDisabled,
  isReadOnly,
  isInvalid,
  helpText,
  size,
  innerRef,
  id,
  showCharacterCount,
  maxLength,
  errorMessage,
  min,
  max,
  step,
  label,
  name,
  value,
  color,
  defaultValue,
  leftIcon,
  rightIcon,
  onBlur,
  onChange,
  onFocus,
  onKeyDown,
  onKeyUp,
  className,
  leftBlock,
  rightBlock,
  rightElem,
  ...rest
}) => {
  const {
    colors: { gray, red, neutral },
    size: { input },
  } = React.useContext<any>(ThemeContext);

  return (
    <Box
      // minHeight={input[size].minHeight + "px"}
      className={`Zeta-InputWrapper`}
      flex={rest.flex}
      mt={rest.mt}
      width="100%"
      {...rest}
    >
      {label && (
        <Label htmlFor={name} size={size}>
          {label}
        </Label>
      )}
      <Flex alignItems="center" flexWrap="nowrap">
        {leftBlock && (
          <Flex
            px={3}
            height={input[size].height + "px"}
            alignItems="center"
            justifyContent="center"
            border={`2px solid gray.200`}
            borderRadius="4px 0 0 4px"
            borderRight="0"
          >
            {typeof leftBlock === "function" ? leftBlock(size) : leftBlock}
          </Flex>
        )}
        <Box position="relative" flex="1" className="Icon-and-Input-Wrapper">
          {leftIcon && (
            <IconBox icon={leftIcon} iconPos="left" color="gray.400" />
          )}
          <StyledInput
            readOnly={isReadOnly}
            id={name}
            disabled={isDisabled}
            className={`Zeta-Input ${className}`}
            ref={innerRef}
            autoComplete="off"
            {...{
              value,
              defaultValue,
              maxLength,
              color,
              placeholder,
              type,
              isInvalid,
              onBlur,
              onChange,
              onFocus,
              onKeyDown,
              style,
              min,
              max,
              onKeyUp,
              leftIcon,
              rightIcon,
              leftBlock,
              rightBlock,
              rightElem,
              size,
            }}
          />
          {rightIcon && (
            <IconBox icon={rightIcon} iconPos="right" color="gray.400" />
          )}
          {rightElem && rightElem}
        </Box>
        {rightBlock && (
          <Flex
            px={3}
            height={48}
            alignItems="center"
            justifyContent="center"
            border={`2px solid gray.200`}
            borderRadius="0 4px 4px 0"
            borderLeft="0"
          >
            {rightBlock}
          </Flex>
        )}
      </Flex>

      <Feedback
        {...{ isDisabled, isInvalid, size, helpText, errorMessage }}
        theme={{ colors: { red, gray } }}
      />
    </Box>
  );
};

export default Input;

Input.defaultProps = {
  size: "regular",
  // errorMessage: "This field is required",
  className: "",
  color: "blue",
};

Input.propTypes = {
  size: propTypes.oneOf(["big", "regular", "small"]),
};

/*
TODO: LIST 
  1. Phone Number Input (Fix the Flicker) use countryfns
  1b. Frontend Validation onChange for Phone Number [Moved to Yup]
  5. Address Input @sage

*/

const allowedKeys = [8, 13, 9, 37, 39];
export const handleKeyDown = (e, onKeyDown) => {
  let preventCondition =
    (!allowedKeys.includes(e.keyCode) && e.keyCode < 48) || e.keyCode > 57;

  if (preventCondition) {
    e.preventDefault();
    return;
  } else {
    onKeyDown && onKeyDown(e);
  }
};

export {
  AddressInput,
  IconBox,
  IconWrapper,
  HelperText,
  Label,
  Feedback,
  StyledInput,
  borderRadiusOptions,
};
